/* rails-erb-loader-dependencies ../config/credentials.yml.enc ../config/initializers/00open_director_constants.rb */
export default {
    app_name: "OpenDirector",
    app_host: "opendirector",
    open_rem_app_host: "openremuneration",
    job_post_app_host: "openpeople",
    company_name: "BigFuture Pty Ltd",
    company_website: "https://www.bigfuture.com.au",
    info_email: "info@opendirector.com.au",
    open_rem_app_name: "OpenRemuneration",
    open_rem_email: "info@opendirector.com.au",
    plans: {"plan_starter":{"id":"starter","name":"Starter","level":1,"active":false,"price":10},"plan_profile":{"id":"create-profile-free","name":"Create Profile","level":2,"active":false,"price":0},"plan_individual":{"id":"institutional-single-user","name":"Premium Single User","level":3,"active":false,"price":270},"plan_institutional":{"id":"enterprise","name":"Premium Enterprise","level":4,"active":false,"price":500},"plan_old_profile":{"id":"create-profile","name":"Create Profile Monthly","level":2,"active":false,"price":15},"plan_old_institutional":{"id":"institutional","name":"Premium Enterprise","level":4,"active":false,"price":500},"plan_new_standard":{"id":"new-standard","name":"Standard Monthly","level":3,"active":false,"price":60},"plan_standard":{"id":"standard","name":"Standard","level":3,"active":false,"price":67},"plan_quarter":{"id":"opendirector-quarterly-plan","name":"Quarterly Plan","level":4,"active":true,"price":3000}},
    remuneration_plan: "open_remuneration",
    job_post_plan: "job_post",
    job_post_app_name: "OpenPeople",
    bugsnag_key: "60c24ad734dddf8326ed6967feb64f6c",
    public_plan: "public",
    release_state: "production",
    stripe_key: "pk_live_ddAQg2nFdzef3NEGNxi1cHHD00vwF1HnXn"
}
